import Button from "@/components/Button"
import Field from "@/components/Field"
import TextInput from "@/components/TextInput"
import {
  BrowserPersistence
} from "@/util"
import {
  isRequired
} from "@/util/formValidators"
import {
  Form
} from "informed"
import {
  useEffect
} from "react"
import {
  useInformationForm
} from "./useInformationForm"
import classes from "./virtualAppointments.module.css"

const storage = new BrowserPersistence()

export const InformationForm = (props) => {
  const {
    appointmentData,
    setCompleteStep2,
    setFormData,
    isUpdate,
    formDataId,
  } = props

  const talonProps = useInformationForm({
    appointmentData,
    isUpdate,
    formDataId,
  })
  const {
    isLoading, handleSubmit, response 
  } = talonProps
  const formdata = {
    initialValues: isUpdate
      ? JSON.parse(storage.getItem("formData"))
      : null,
  }

  useEffect(() => {
    if (response && response.code === "200") {
      setCompleteStep2(true)
      setFormData(JSON.parse(response.content))
    }
  }, [response, setCompleteStep2, setFormData])

  const errorInfo =
        response && response.message === "error" ? (
          <span className={classes.errorInfo}>{response.content}</span>
        ) : null

  return (
    <div className={classes.formContainer}>
      <Form
        className={classes.form}
        onSubmit={handleSubmit}
        {...formdata}
      >
        <Field id='first-name' label={<span className='text-[15px]'>First Name</span>} required>
          <TextInput
            autoComplete='firstname'
            field='firstname'
            id='firstName'
            validate={isRequired}
          />
        </Field>
        <Field id='last-name' label={<span className='text-[15px]'>Last Name</span>} required>
          <TextInput
            autoComplete='lastname'
            field='lastname'
            id='lastName'
            validate={isRequired}
          />
        </Field>
        <Field id='phone' label={<span className='text-[15px]'>Phone</span>} required>
          <TextInput
            autoComplete='phone'
            field='phone'
            id='Phone'
            validate={isRequired}
          />
        </Field>
        <Field id='email' label={<span className='text-[15px]'>Email</span>} required>
          <TextInput
            autoComplete='email'
            field='email'
            id='Email'
            validate={isRequired}
          />
        </Field>
        <div>
          <p className={classes.formtip}>
                        You will receive a text message reminder before your
                        appointment
          </p>
          <Button
            type='submit'
            className={classes.submitButton}
            disabled={!!isLoading}
          >
            {isLoading ? "SUBMITTING..." : "SUBMIT"}
          </Button>
        </div>
        {errorInfo}
      </Form>
    </div>
  )
}

export default InformationForm
